import xlWaterRequest from "../utils/xlWaterRequest";

const DEVICE_HEADERS = {
  Accept: "application/json",
  platform: "PC",
  "mr-future.2022-key": "value-2022.mr-future",
  SystemUpdate: 1,
  "Content-Type": "application/x-www-form-urlencoded"
};
const FORM_HEADERS = {
  Accept: "*/*",
  "Content-Type": "application/x-www-form-urlencoded"
};

function normalizeResponse(response) {
  if (typeof response !== "string") {
    return response;
  }

  const text = response.trim();
  if (!text) {
    return {};
  }

  try {
    return JSON.parse(text);
  } catch (error) {
    return text;
  }
}

export function getSingleDeviceData(data) {
  return xlWaterRequest({
    url: "/interface/GetSingleDeviceDataPro",
    method: "get",
    loading: true,
    headers: DEVICE_HEADERS,
    params: data
  });
}

export function refreshDeviceData({
  username,
  password,
  ProductKey,
  DeviceName
}) {
  return xlWaterRequest({
    url: "/GetDviceDataNowByXueLing",
    method: "post",
    headers: FORM_HEADERS,
    data: {
      username,
      password,
      ProductKey,
      DeviceName,
      label: "change",
      message: "AA01"
    }
  }).then(normalizeResponse);
}

export function setSingleDeviceData(data) {
  return xlWaterRequest({
    url: "/interface/SetSingleDeviceDataPro",
    method: "post",
    headers: FORM_HEADERS,
    data
  }).then(normalizeResponse);
}
